import { Component, computed, input } from '@angular/core';

import { PillsOverflowComponent } from '@shared/components/pills-overflow/pills-overflow.component';
import { stringsToPillItems } from '@shared/components/pills-overflow/pills-overflow.utils';
import {
  formatCellValue,
  processUidListValue
} from '@shared/components/table/table-cell/utils';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';

@Component({
  selector: 'app-text-list-cell',
  imports: [PillsOverflowComponent],
  templateUrl: './text-list-cell.component.html'
})
export class TextListCellComponent {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'text-list');

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<string[] | undefined>(() =>
    processUidListValue(this.value())
  );

  protected pillItems = computed(() => {
    const values = this.processedValue();
    return values ? stringsToPillItems(values) : [];
  });
}
